import { connect } from 'react-redux';
import moment from '~/Providers/Moment';

import DayView from '~/Components/Pages/Calendar/DayView/DayView';

import { setDayType } from '~/Redux/Modules/DateRange';
import { openPresetModal } from '~/Redux/Modules/Events';
import { findCalendarInList, mapCalendarsToList } from '~/Redux/Modules/CalendarAccounts';
import { DEFAULT_TIME_ZONE } from '~/Redux/Constants';
import { filterEventsByCalendarDisplay } from '~/Redux/Modules/Events/selectors';

const mapStateToProps = ({ DateRange, Events, UserOptions, CalendarAccounts }) => {
  const calendarDisplayOptions = {
    includeMonthView: true,
    includeWeekView: true,
    includeDayView: false,
  };
  const calendarMap = CalendarAccounts.calendarMap;
  const filteredEvents = filterEventsByCalendarDisplay(
    Events.formattedData,
    calendarDisplayOptions,
    calendarMap
  );

  return {
    currentDay: DateRange.today,
    start: DateRange.start,
    end: DateRange.end,
    events: filteredEvents, //this handles hiding dayView all-day events
    defaultCalendar:
      findCalendarInList(mapCalendarsToList(CalendarAccounts), UserOptions.data.calendar_id) || {},
    userTimeZone: moment.tz.guess() || DEFAULT_TIME_ZONE,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPresetModal: update => dispatch(openPresetModal(update)),
    setDayType: start => dispatch(setDayType(start, false, false)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DayView);
